import { createAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../../store'

export type LiveCallMonitorState = {
  open: boolean
}

const initialState: LiveCallMonitorState = {
  open: false,
}

export const setLiveCallMonitorOpen = createAction<boolean>(
  'liveCallMonitor/setOpen',
)

export const toggleLiveCallMonitor = createAction<void>(
  'liveCallMonitor/toggle',
)

export const liveCallMonitorSlice = createSlice({
  name: 'liveCallMonitor',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(toggleLiveCallMonitor, (state) => {
      state.open = !state.open
    })
    builder.addCase(setLiveCallMonitorOpen, (state, { payload }) => {
      state.open = payload
    })
  },
})

export const selectLiveCallMonitorOpen = ({ liveCallMonitor }: RootState) => {
  return liveCallMonitor.open
}
